import { makeStyles } from '@material-ui/core/styles'
import { themeCommon } from '../../theme'

const useStyles = makeStyles((theme) => ({
    rootAccordion: {
        boxShadow: 'none',
        boxShadow: '0px 0px 3px rgba(0, 0, 0, 0.25)',
        borderRadius: '10px !important',
        margin: '20px 0',
        padding: '10px',
        minHeight: '470px',
    },
    contentAccordionSummary: {
        margin: '0 !important',
        minHeight: '350px',
        alignItems: 'baseline',
        [theme.breakpoints.down('lg')]: {
            justifyContent: 'flex-end',
            marginBottom: '10px',
        },
        [theme.breakpoints.down('md')]: {
            justifyContent: 'flex-end',
            marginBottom: '10px',
        },
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'center',
            marginBottom: '30px',
        },
    },
    rootGridMobileStepper: {
        justifyContent: 'flex-end',
        [theme.breakpoints.down('lg')]: {
            justifyContent: 'flex-end',
        },
        [theme.breakpoints.down('md')]: {
            justifyContent: 'flex-end',
        },
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'center',
        },
    },
    rootMuiMobileStepper: {
        width: '147px',
        height: '15px',
        [theme.breakpoints.down('lg')]: {
            width: '147px',
        },
        [theme.breakpoints.down('md')]: {
            width: '147px',
        },
        [theme.breakpoints.down('sm')]: {
            width: '175px',
            marginRight: '10px',
        },
    },
    progressMuiMobileStepper: {
        background: '#D7D7D7',
        height: '15px',
        borderRadius: '10px',
        width: '100%',
        '& > div': {
            background: themeCommon.lightBlue,
            borderRadius: '10px',
        }
    },
    barColorMuiMobileStepper: {
        backgroundColor: '#0492C2',
    },
    img: {
        height: 255,
        maxWidth: 400,
        overflow: 'hidden',
        display: 'block',
        width: '100%',
    },
    rootMuiAccordionDetails: {
        display: 'block',
    },
    rootGridButton: {
        marginBottom: '10px',
        justifyContent: 'flex-end',

        [theme.breakpoints.down('lg')]: {
            justifyContent: 'flex-end',
            marginBottom: '10px',
        },
        [theme.breakpoints.down('md')]: {
            justifyContent: 'flex-end',
            marginBottom: '10px',
        },
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'center',
            marginBottom: '30px',
        },
    },
    rootGrid: {
        display: 'block',
    },
    rootTypographyQuestion: {
        fontFamily: themeCommon.RobotoBold,
    },
    typographyDown: {
        [theme.breakpoints.down('lg')]: {
            fontSize: themeCommon.fontSize18px,
        },
        [theme.breakpoints.down('md')]: {
            fontSize: themeCommon.fontSize16px,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize14px,
        },
    },
    checkbox: {
        color: '#7A7A7A',
    },
}), {
    name: 'SurveyQuestionContainerHeadContainer',
    index: 1,
})

export default useStyles